import { Container, Navbar, Nav } from "react-bootstrap"
import { Link } from "react-router-dom"
import "./Header.css"

const Header=() => {
return (
    <>
    <Navbar bg="primary" variant="dark">
        <Container>
            <Navbar.Brand to="/"><strong>Employee Management System</strong></Navbar.Brand>
            <Nav className="ml-auto" >
            <Nav.Link as={Link} to="/">Employees</Nav.Link>
            <Nav.Link as={Link} to="/employee">Post Employee</Nav.Link>
            </Nav>
        </Container>

    </Navbar>
    </>
)

}

export default Header;